import React, { useState, useEffect, useContext } from 'react';
//import 'bulma/css/bulma.min.css';
import '../view-archer-styles.css';

// material-ui: theme, colors, icons
import { Alert, Card, CardContent, Chip, CardActions, Divider, Grid, Link, Stack, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material/';
import { deepOrange, green, pink, blue, red } from '@mui/material/colors';
import { EditCalendarOutlined, WatchLater } from '@mui/icons-material/';
import ArcherLetter from '../dataObjects/ArcherLetter';

import { AuditorCommunicationContext } from '../view-archer';

interface Props {
    upcomingFollowupLetters?: ArcherLetter[];
}


const DashboardUpcoming205s = (props: Props) => {

    const context = useContext(AuditorCommunicationContext);

    const setCurrentLetterCpfId = (cpfId: number) => {
        context.setCurrentLetterCpfId(cpfId);
    }

    return (
        <div>
            <Card className="dashboard-tile">
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container alignContent="center" justifyContent="space-between">
                                <Grid item>
                                    <Typography variant="subtitle1" color="blue">Upcoming Scheduled Follow up Letters {props.upcomingFollowupLetters && `(${props.upcomingFollowupLetters.length})`}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            {
                                props.upcomingFollowupLetters && props.upcomingFollowupLetters.length === 0 &&
                                <Alert severity="success" sx={{ margin: 2 }}>There are no scheduled Audit follow up letters!</Alert>
                            }
                            {
                                props.upcomingFollowupLetters && props.upcomingFollowupLetters.length > 0 && 
                                <TableContainer sx={{ maxHeight: 265 }}>
                                    <Table sx={{ minWidth: 650 }} aria-label="scheduled letters table">
                                        <TableBody>
                                            {
                                                props.upcomingFollowupLetters?.map((letter: ArcherLetter, index: number) =>
                                                    <TableRow key={index}>
                                                        <TableCell>
                                                            <Chip icon={<WatchLater />} label={`${letter.date}`} color="primary" variant="outlined" />
                                                        </TableCell>
                                                        <TableCell sx={{ textAlign: "left!important" }}><Typography variant="body2" className="is-clickable" onClick={() => setCurrentLetterCpfId(letter.cpfId)}><b>{letter.filerDisplayName}</b></Typography></TableCell>
                                                        <TableCell sx={{ textAlign: "left!important" }}>
                                                            <Stack spacing={2}>
                                                                {
                                                                    letter.issueListings &&
                                                                    letter.issueListings.map((issue) => <span key={issue.issueId}><span className={issue.status} >{issue.issueTypeCode} {issue.header}</span>
                                                                        <Link key={issue.letterId} onClick={() => setCurrentLetterCpfId(letter.cpfId)}> (<i>{issue.date}</i>)</Link>
                                                                    </span>)
                                                                }
                                                            </Stack>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Stack direction="row" spacing={1}>
                                                                <EditCalendarOutlined fontSize="small" className="is-clickable" />
                                                            </Stack>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            }
                            
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </div>
    )
}

export default DashboardUpcoming205s;